'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { CgClose } from 'react-icons/cg';
interface RibbonConfig {
  enabled: boolean;
  badge: string;
  message: string;
  link_text: string;
  link_url: string;
  bg_color: string;
}
interface IProps {
  onVisibilityChange: (visible: boolean) => void;
}
const STORAGE_PREFIX = 'ribbon-dismissed-';
export const WebinarRibbon = t0 => {
  const $ = _c(26);
  const {
    onVisibilityChange
  } = t0;
  const [config, setConfig] = useState(null);
  const [visible, setVisible] = useState(false);
  let t1;
  let t2;
  if ($[0] !== onVisibilityChange) {
    t1 = () => {
      const apiUrl = process.env.NEXT_PUBLIC_RIBBON_API_URL;
      if (!apiUrl) {
        onVisibilityChange(false);
        return;
      }
      fetch(apiUrl).then(_temp).then(data => {
        if (!data.enabled || !data.message) {
          onVisibilityChange(false);
          return;
        }
        const key = STORAGE_PREFIX + encodeURIComponent(data.message).slice(0, 32);
        if (localStorage.getItem(key)) {
          onVisibilityChange(false);
          return;
        }
        setConfig(data);
        setVisible(true);
        onVisibilityChange(true);
      }).catch(() => onVisibilityChange(false));
    };
    t2 = [onVisibilityChange];
    $[0] = onVisibilityChange;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== config || $[4] !== onVisibilityChange) {
    t3 = () => {
      if (!config) {
        return;
      }
      const key_0 = STORAGE_PREFIX + encodeURIComponent(config.message).slice(0, 32);
      localStorage.setItem(key_0, "1");
      setVisible(false);
      onVisibilityChange(false);
    };
    $[3] = config;
    $[4] = onVisibilityChange;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const dismiss = t3;
  if (!visible || !config) {
    return null;
  }
  let t4;
  if ($[6] !== config.bg_color) {
    t4 = {
      backgroundColor: config.bg_color
    };
    $[6] = config.bg_color;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== config.badge) {
    t5 = config.badge && <span className="hidden flex-shrink-0 rounded-full bg-white/20 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-widest text-white sm:inline-flex">{config.badge}</span>;
    $[8] = config.badge;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== config.message) {
    t6 = <span className="min-w-0 truncate text-[13px] font-medium text-white">{config.message}</span>;
    $[10] = config.message;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== config.link_text || $[13] !== config.link_url) {
    t7 = config.link_url && config.link_text && <><span className="hidden h-1 w-1 flex-shrink-0 rounded-full bg-white/40 sm:block" /><Link href={config.link_url} style={{
        color: "#ffffff"
      }} className="flex-shrink-0 text-[13px] font-semibold opacity-90 hover:opacity-100">{config.link_text}</Link></>;
    $[12] = config.link_text;
    $[13] = config.link_url;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t6 || $[17] !== t7) {
    t8 = <div className="flex min-w-0 items-center gap-2 sm:gap-3">{t5}{t6}{t7}</div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <CgClose size={16} />;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== dismiss) {
    t10 = <button onClick={dismiss} aria-label="Dismiss announcement" className="absolute right-3 top-1/2 -translate-y-1/2 text-white/60 transition-colors hover:text-white sm:right-4">{t9}</button>;
    $[20] = dismiss;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t4 || $[24] !== t8) {
    t11 = <div className="fixed left-0 right-0 top-0 z-[51] flex h-11 items-center px-10 sm:justify-center sm:px-12" style={t4}>{t8}{t10}</div>;
    $[22] = t10;
    $[23] = t4;
    $[24] = t8;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
};
function _temp(r) {
  return r.json();
}